const currencyFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const fractionCurrencyFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 2
});
export const formatCurrencyRub = (amount) => {
    if (amount % 1 === 0)
        return currencyFormatter.format(amount).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
    else
        return fractionCurrencyFormatter.format(amount).replace(/\B(?=(\d{3})+(?!\d))/g, '\xa0');
};
